import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import FormLabel from '@mui/material/FormLabel'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Grid from '@mui/material/Grid'
import { Alert, AlertTitle, Box, Checkbox, Collapse, ListItemText, Paper, Snackbar, Typography } from '@mui/material'

const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

// Roles del funcionario (mismos ids que el parametro dashboard_funcionarios_roles).
// label = texto mostrado; nombre = nombre canonico que se guarda (consistente con editar).
const ROLES_FUNCIONARIO = [
  { id: "2147483648", nombre: "Administrador",  label: "Administrador de maquina" },
  { id: "536870912",  nombre: "Tecnico",        label: "Mantenimiento de maquina" },
  { id: "1073741824", nombre: "Trans.Valores",  label: "Transportador de bolsa" },
]

class FuncionariosCrearPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
          entidades: [],
          txtNombre: "",
          txtCodigo: "",
          txtPassword: "",
          cmbFuncionario: [],
          cmbEntidades: 0,
          idNuevoFuncionario: 0,

          mostrarAlerta: false,
          mensajeAlerta: '',
          severidadAlerta: 'info'
        }

    }

    handleCloseAlert= (event, reason) => {
      if (reason === 'clickaway') {
        return; // Evitar que se cierre si el usuario hace clic fuera
      }
      this.setState({ mostrarAlerta: false })
    }

    onChangetxtNombre = (event) => {
      const nombre = event.target.value.toString()
      this.setState({txtNombre: nombre})
    }


    onChangecmbEntidades = (event) => {
      const entidad = event.target.value
      this.setState({cmbEntidades: entidad})
    }

    onChangetxtPassword = (event) => {
        // Solo numerico, sin simbolos, maximo 10 digitos
        const password = event.target.value.replace(/\D/g, '').slice(0, 10)
        this.setState({txtPassword: password})
    }

    onChangecmbFuncionario = (event) => {
        const value = event.target.value
        this.setState({ cmbFuncionario: typeof value === 'string' ? value.split(',') : value })
    }
    
    onChangetxtCodigo = (event) => {
      // Solo numerico, sin simbolos, maximo 10 digitos
      const codigo = event.target.value.replace(/\D/g, '').slice(0, 10)
      this.setState({txtCodigo: codigo})
    }

    componentDidMount() {
      this.queryEntidades()
    }

    btnAgregarFuncionarioClick = () => {
        console.log('Agregando usuario....')

        var continuar = true
        var mensajeError = "Error:\n"

        var nombre = this.state.txtNombre
        var codigo = this.state.txtCodigo
        var password = this.state.txtPassword


        nombre = nombre.trim()
        codigo = codigo.trim()
        password = password.trim()
        
        if(nombre === '') {
          continuar = false
          mensajeError += " * Debe ingresar el nombre.\n"
        }



        if(codigo === '') {
          continuar = false
          mensajeError += " * Debe ingresar el codigo.\n"
        }
        else if(!/^\d{1,10}$/.test(codigo)) {
          continuar = false
          mensajeError += " * La identificación debe ser numérica, sin símbolos y máximo 10 dígitos.\n"
        }


        if(password === '') {
          continuar = false
          mensajeError += " * Debe ingresar la contraseña.\n"
        }
        else if(!/^\d{1,10}$/.test(password)) {
          continuar = false
          mensajeError += " * La contraseña debe ser numérica, sin símbolos y máximo 10 dígitos.\n"
        }
    
        var roles = ROLES_FUNCIONARIO
                      .filter(r => this.state.cmbFuncionario.indexOf(r.id) !== -1)
                      .map(r => ({ nombre: r.nombre, id: r.id }))

        if(continuar) {
			var restArgs = {
		      method: 'PUT',
		      headers: 'JSON',
		      body: {
			  	nombre: nombre,
                codigo: codigo,
                password: password,
                roles: roles
			  },
		      url: process.env.REACT_APP_URL_BACKEND + '/funcionarios/new'
		    }
		
		    RestTunel.makePetition(restArgs,(err, data) => {
		      if(err) {
		        //console.log('Error respuesta insertar funcionario')
                this.setState({
                  mensajeError: data.message,
                  mostrarAlerta: true,
                  mensajeAlerta: 'Error: Se produjo un error creando el funcionario.',
                  severidadAlerta: 'error'
                })
                //alert("Error: Se produjo un error creando el funcionario.")
		      } else {
		        //console.log('Funcionario insertado')
                // alert("Nuevo funcionario creado")
                this.setState({
                  idNuevoFuncionario: data,
                  mostrarAlerta: true,
                  mensajeAlerta: 'Nuevo funcionario creado',
                  severidadAlerta: 'success'
                }, ()=>{this.btnLimpiarClick2()})
		      }
		    })
			
        } else {
          //alert(mensajeError)
          this.setState({
            mostrarAlerta: true,
            mensajeAlerta: mensajeError,
            severidadAlerta: 'error'
          })
        }
        
    }

    

    btnLimpiarClick = () => {
      this.setState({
        txtNombre: "",
        txtCodigo: "",
        txtPassword: "",
        cmbFuncionario: [],
        cmbEntidades: 0,
        idNuevoFuncionario: 0
      })
    }

     btnLimpiarClick2 = () => {
      this.setState({
        txtNombre: "",
        txtCodigo: "",
        txtPassword: "",
        cmbFuncionario: [],
        cmbEntidades: 0
      })
    }

    queryEntidades() {
      //console.log('Consultando entidades....')
      var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/entidades/usuario/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        //alert("Error consultando entidades")
        //console.log('Error respuesta consultando entidades')
        this.setState({
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando entidades',
          severidadAlerta: 'error'
        })
      } else {
        //console.log('Entidades consultadas')
        this.setState({
          entidades: data,
          mostrarAlerta: true,
          mensajeAlerta: 'Entidades consultadas',
          severidadAlerta: 'success'
          
        })
      }
    })
      
    }

    render() {
        return(
          <Box>
            
              <Typography gutterBottom variant="h5" component="div" sx={{ marginBottom: 2 }}>
                Crear Funcionario
              </Typography>

              <Paper elevation={16}>
                <Card>
                    <CardContent>
                        <form>
                            <FormLabel>Información funcionario</FormLabel>
                            <Grid container spacing={2} rowSpacing={2}>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <TextField
                                  label="Nombre"
                                  id="outlined-basic"
                                  variant="outlined"
                                  value={this.state.txtNombre}
                                  onChange={this.onChangetxtNombre}
                                  fullWidth
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <TextField
                                  label="Identificación"
                                  id="outlined-basic"
                                  variant="outlined"
                                  value={this.state.txtCodigo}
                                  onChange={this.onChangetxtCodigo}
                                  inputProps={{ inputMode: 'numeric', maxLength: 10, pattern: '[0-9]*' }}
                                  helperText="No se podrá cambiar después de crear (no editable)"
                                  fullWidth
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <TextField
                                    label="Contraseña"
                                    id="outlined-basic"
                                    type="password"
                                    variant="outlined"
                                    value={this.state.txtPassword}
                                    onChange={this.onChangetxtPassword}
                                    inputProps={{ inputMode: 'numeric', maxLength: 10, pattern: '[0-9]*' }}
                                    fullWidth
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <InputLabel>Funcionario</InputLabel>
                                  <Select
                                    multiple
                                    label="Funcionario"
                                    value={this.state.cmbFuncionario}
                                    onChange={this.onChangecmbFuncionario}
                                    renderValue={(selected) => ROLES_FUNCIONARIO.filter(r => selected.indexOf(r.id) !== -1).map(r => r.label).join(', ')}>
                                    {ROLES_FUNCIONARIO.map(rol => (
                                      <MenuItem key={rol.id} value={rol.id}>
                                        <Checkbox checked={this.state.cmbFuncionario.indexOf(rol.id) !== -1} />
                                        <ListItemText primary={rol.label} />
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                            </Grid>                   
                        </form>
                      </CardContent>
                      <CardActions>
                          <Button  variant="contained" onClick={this.btnAgregarFuncionarioClick}>Crear Funcionario</Button>
                          <Snackbar
                                            open={this.state.mostrarAlerta}
                                            onClose={this.handleCloseAlert}
                                            autoHideDuration={3000}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                            >
                                            <Collapse in={this.state.mostrarAlerta}>
                                                <Alert
                                                    severity={this.state.severidadAlerta}
                                                    onClose={this.handleCloseAlert}
                                                    sx={{ marginTop: 4, width:'100%'}}
                                                    >
                                                <AlertTitle>
                                                    {this.state.severidadAlerta.toUpperCase()}
                                                </AlertTitle>
                                                    {this.state.mensajeAlerta}
                                                </Alert>
                                            </Collapse>
                          </Snackbar> 
                          <Button  variant="contained" onClick={this.btnLimpiarClick}>Limpiar</Button>
                          <Snackbar
                                            open={this.state.mostrarAlerta}
                                            onClose={this.handleCloseAlert}
                                            autoHideDuration={3000}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                            >
                                            <Collapse in={this.state.mostrarAlerta}>
                                                <Alert
                                                    severity={this.state.severidadAlerta}
                                                    onClose={this.handleCloseAlert}
                                                    sx={{ marginTop: 4, width:'100%'}}
                                                    >
                                                <AlertTitle>
                                                    {this.state.severidadAlerta.toUpperCase()}
                                                </AlertTitle>
                                                    {this.state.mensajeAlerta}
                                                </Alert>
                                            </Collapse>
                          </Snackbar> 
                      </CardActions>
                </Card>
              </Paper>
    
                <br />
                { this.state.idNuevoFuncionario !== 0 &&
                  <Link to={{pathname: '/dashboard/funcionarios/editar', state: {id_funcionario: this.state.idNuevoFuncionario}}} style={{ textDecoration: 'none' }}><Button variant="contained" color="info">Configurar nuevo Funcionario</Button></Link>
                }
                <Snackbar
                                            open={this.state.mostrarAlerta}
                                            onClose={this.handleCloseAlert}
                                            autoHideDuration={3000}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                            >
                                            <Collapse in={this.state.mostrarAlerta}>
                                                <Alert
                                                    severity={this.state.severidadAlerta}
                                                    onClose={this.handleCloseAlert}
                                                    sx={{ marginTop: 4, width:'100%'}}
                                                    >
                                                <AlertTitle>
                                                    {this.state.severidadAlerta.toUpperCase()}
                                                </AlertTitle>
                                                    {this.state.mensajeAlerta}
                                                </Alert>
                                            </Collapse>
                </Snackbar> 
            
          </Box>
        )
    }

}


export default FuncionariosCrearPage